import React from 'react';
import { EyeIcon, RequestIcon, MailIcon } from '../utils/IconSet';

type DashboardTopCardsProps = {
    onTabClick?: (tab: string) => void;
    watchList?: any[];
    reqOwnerCount?: number;
    reqUserCount?: number;
    msgOwnerCount?: number;
    msgUserCount?: number;
};

export default function DashboardTopCards({ onTabClick, watchList, reqOwnerCount = 0, reqUserCount = 0, msgOwnerCount = 0, msgUserCount = 0 }: DashboardTopCardsProps) {
    return (
        <div className="dashboard-top">
            <div className="dashboard-top-cards">
                <div className="dashboard-card clickable" onClick={() => { onTabClick?.('watchlist'); window.location.hash = '#watchlist'; }}>
                    <div className="dashboard-card-icon">
                        <div className="binocular">
                            <EyeIcon size={22} />
                            <EyeIcon size={22} />
                        </div>
                    </div>
                    <div className="dashboard-card-title">WatchList</div>
                    <div className="dashboard-card-count">{Array.isArray(watchList) ? watchList.length : 0}</div>
                </div>
                <div className="dashboard-card clickable" onClick={() => { onTabClick?.('requests'); window.location.hash = '#requests'; }}>
                    <div className="dashboard-card-icon"><RequestIcon size={22} /></div>
                    <div className="dashboard-card-title">Requests</div>
                    <div className="dashboard-card-counts" style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <div className="dashboard-card-count dashboard-card-count-received" title="Requests received" style={{ fontSize: 16 }}>
                            Received : {reqOwnerCount}
                        </div>
                        <div className="dashboard-card-count dashboard-card-count-made" title="Requests made" style={{ fontSize: 14, color: '#666' }}>
                            Sent : {reqUserCount}
                        </div>
                    </div>
                </div>
                <div className="dashboard-card clickable" onClick={() => { onTabClick?.('messages'); window.location.hash = '#messages'; }}>
                    <div className="dashboard-card-icon"><MailIcon size={22} /></div>
                    <div className="dashboard-card-title">Messages</div>
                    <div className="dashboard-card-counts" style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <div className="dashboard-card-count dashboard-card-count-received" title="Messages received" style={{ fontSize: 16 }}>
                            Received : {msgOwnerCount}
                        </div>
                        <div className="dashboard-card-count dashboard-card-count-made" title="Messages sent" style={{ fontSize: 14, color: '#666' }}>
                            Sent : {msgUserCount}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
